import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
interface TestimonialsSectionProps {
  variant?: 'strip' | 'grid';
}
function initials(author: string): string {
  return author.split(' ').map(part => part.charAt(0)).join('').toUpperCase();
}

/**
 * `strip` — compact proof right under the hero (first three quotes).
 * `grid` — the full wall of coach quotes after the offer.
 */
export function TestimonialsSection({
  variant = 'grid'
}: TestimonialsSectionProps) {
  const isStrip = variant === 'strip';
  // Strip and wall never repeat a coach: first two up top, last three at the end.
  const items = isStrip ? testimonials.slice(0, 2) : testimonials.slice(-3);
  const headingId = `testimonials-${variant}-heading`;
  return <section className="defer-paint w-full border-b border-line bg-canvas py-10 sm:py-16" aria-labelledby={headingId} data-id="element-245" data-mp="2yfgz0wtjyli4">
      <div className="mx-auto max-w-6xl px-5 sm:px-6" data-id="element-246" data-mp="32h2jb38f222c">
        {isStrip ? <h2 id={headingId} className="flex items-center justify-center gap-2 text-center text-sm font-bold uppercase tracking-widest text-navy" data-id="element-247" data-mp="2v1kq8jrps1tn">
            <StarIcon className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-248" data-mp="2q1pzqhbupe94" />
            What Track &amp; Field Coaches Are Saying
          </h2> : <h2 id={headingId} className="text-center font-display text-2xl font-bold leading-tight text-navy sm:text-4xl" data-id="element-249" data-mp="34t8cm69eyso9">
            What Coaches Using the System Are Saying
          </h2>}

        <ul className={`${isStrip ? 'mt-6' : 'mt-8'} flex flex-wrap justify-center gap-4`} data-id="element-250" data-mp="2c4t31z91x2kb">
          {items.map(testimonial => <li key={testimonial.author} className="flex w-full flex-col rounded-2xl border border-line bg-white p-5 shadow-sm md:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.667rem)]" data-id="element-251" data-mp="2m0w9vieulpdl">
              <div className="flex items-start justify-between" data-id="element-252" data-mp="2h45yh8dznhyi">
                <div className="flex gap-0.5" role="img" aria-label="5 out of 5 stars" data-id="element-253" data-mp="193z64qb9g89">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-254" data-mp="3fadgo46l3s5" data-mpi={index} />)}
                </div>
                {!isStrip ? <QuoteIcon className="h-7 w-7 fill-gold-tint text-gold/60" aria-hidden="true" data-id="element-255" data-mp="8cah6sdk5ug3" /> : null}
              </div>

              <blockquote className="mt-4 text-sm italic leading-relaxed text-body" data-id="element-256" data-mp="davherst8e4j">
                “{testimonial.quote}”
              </blockquote>

              <footer className="mt-auto flex items-center gap-3 pt-6" data-id="element-257" data-mp="3guggtnpdvmbs">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy text-xs font-bold text-white" aria-hidden="true" data-id="element-258" data-mp="3lsi8gx0vktyv">
                  {initials(testimonial.author)}
                </span>
                <span className="text-sm" data-id="element-259" data-mp="3vjmmnuiq8asn">
                  <span className="block font-bold text-navy" data-id="element-260" data-mp="3vknzo4jaz7d0">
                    {testimonial.author}
                  </span>
                  <span className="block text-xs text-body" data-id="element-261" data-mp="3320k14n2skjb">
                    {isStrip ? testimonial.role : `${testimonial.program} · ${testimonial.role}`}
                  </span>
                </span>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}